var unirest = require('unirest');
const API = require ('Api') ;


export async function getRelatives ( token, personaID ) {
        const res =  await unirest.get(API.V2 + API.PERSONAS  + personaID + "/relatives" )
                .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
        if (res.error) console.log(res.error)
    return res.body ;
}

export async function getPersona ( token, personaID ) {
        const res =  await unirest.get(API.V2 + API.PERSONAS  + personaID )
                .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
        if (res.error) console.log(res.error)
    return res.body ;
}

export async function searchPersona ( token, srchQry ) {
        const res =  await unirest.get(API.V2  + API.PERSONAS + 'search/'+srchQry  )
                .headers({'Authorization': 'Bearer ' + token });
        if (res.error) console.log(res.error)
        let list = res.body ;
    return list ;
    }


    

export async function addRelatedRelation ( token, personaID, relatedID, relationType, isMyProfile  ) {
const res =  await unirest.post(API.V2 + API.PERSONAS+ personaID + "/related/" + relatedID )
        .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
        .send({ "relation_type": relationType, "notes": "" })
if (res.error) console.log(res.error)
let list = res.body ;
return list ;
}  




export async function deleteRelatedRelation ( token, personaID, relatedID) {
        const res =  await unirest.delete(API.V2 + API.PERSONAS+ personaID + "/related/" + relatedID )
                .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
                
        if (res.error) console.log(res.error)
        let list = res.body ;
    return list ;
    }

export async function createPersona ( token , data ) {
        const res =  await unirest.post(API.V2 + API.PERSONAS )
                .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
                .send(data)
        if (res.error) console.log(res.error)
        let list = res.body ;
    return list ;
    }

export async function updatePersona ( token, personaID , data ) {
        const res =  await unirest.put(API.V2 + API.PERSONAS + personaID )
                .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
                .send(data)
        if (res.error) console.log(res.error)
        let list = res.body ;
    return list ;
    }


export async function uploadProfileImage ( token, data ) {

        const res =  await unirest.post(API.V2 + API.FILES + 'images/profile' )
                .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
                .send(data)
        if (res.error) console.log(res.error)
        let list = res.body ;
    return list ;
    }

export async function removeProfileImage (token, personaID , id  ) {
        const res =  await unirest.delete(API.V2 + API.FILES + personaID  + '/images/'+id )
                .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
        if (res.error) console.log(res.error)

        const images = await unirest.get(API.V2 + API.FILES + personaID + "/images" )
        .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})

        let list = images.body ;
    return list ;
    }   
